import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FileEarmark, Folder2, Trash } from 'react-bootstrap-icons';
import SlidingSideBar from '../SlidingSideBar/SlidingSideBar';
import FilePopup from './FilePopup';
import AttachmentDownload from './AttachmentDownload';
import { fileName } from '../../helpers/attachments';
import './FileViewer.css';

export const FileRow = ({file,onFileClick,onFileDeleteClick}) => <div className="attachment-row">
  <div className="attachment-row-name">
    <Button type="button" variant="link" onClick={onFileClick} aria-label={'Preview '+fileName(file)}><FileEarmark className="mr-2"/>{fileName(file)}</Button>
    {file.uploadDate && <div className="small text-muted">{moment(file.uploadDate).format('MMMM Do YYYY hh:mm a')}</div>}
  </div>
  <div className="attachment-row-actions"><AttachmentDownload file={file}/>{onFileDeleteClick && <Button type="button" size="sm" variant="outline-danger" aria-label={'Delete '+fileName(file)} onClick={onFileDeleteClick}><Trash/></Button>}</div>
</div>;

const FileViewer = ({ files = [], show, onHide, sidebarZIndex, onFileDeleteClick, driveFolder, sections, children }) => {
  const [visibleFile, setVisibleFile] = useState();
  const reversedFiles = useMemo(() => (Array.isArray(files) ? files : []).filter(file => file && typeof file === 'object').slice().reverse(), [files]);
  useEffect(() => { if (!show) setVisibleFile(null); }, [show]);

  return (
    <>
      <SlidingSideBar zIndex={sidebarZIndex} visible={show} onClose={onHide} title={'View Files'}>
        {children}
        {driveFolder && (
          <>
            <div className="text-right mb-1">
              <a target="_blank" rel="noopener noreferrer" href={`https://drive.google.com/drive/folders/${driveFolder}`}>
                <Button size="sm" className="px-2 py-1">
                  <Folder2 />
                  <span className="align-middle ml-2">Open Drive</span>
                </Button>
              </a>
            </div>
            <hr className="my-2" />
          </>
        )}

        {reversedFiles.length > 0 ? (
          reversedFiles.map(f => (
            <React.Fragment key={f._id || f.filename}>
              {f?.classifier && (
                <>
                  <h6>{f?.classifier}</h6>
                </>
              )}
              <FileRow
                key={f._id}
                file={f}
                onFileClick={() => setVisibleFile(f)}
                onFileDeleteClick={onFileDeleteClick ? () => onFileDeleteClick({ ...f, payrollId: f?.payrollId }) : undefined}
              />
            </React.Fragment>
          ))
        ) : (
          <p className="p-5 text-center">No files to show!</p>
        )}
        {/* {files?.length !== 0 &&
          sections &&
          allEmptySections.map(emptySection => (
            <h6>
              {emptySection?.title}
              {'  '}
              <span className="tinyFont">(No Files Found)</span>
            </h6>
          ))} */}
      </SlidingSideBar>
      {show && visibleFile && <FilePopup key={visibleFile._id || visibleFile.filename} file={visibleFile} onHide={() => setVisibleFile()} />}
    </>
  );
};

export default FileViewer;
